const watermark = {}
const setWatermark = (str, container) => {//水印内容、容器
  const id = '1.23452384164.123412415'
  //没有容器直接return，这里使用的时候str、container都是必填
  if (container === undefined) {
    return
  }
  // 查看页面上有没有当前id元素，如果有则删除
  if (document.getElementById(id) !== null) {
    const childelement = document.getElementById(id)
    childelement.parentNode.removeChild(childelement)
  }

  var containerWidth = container.offsetWidth // 获取父容器宽
  var containerHeight = container.offsetHeight // 获取父容器高
  container.style.position = 'relative' // 设置布局为相对布局

  // 创建canvas元素(先制作一块背景图)
  const img= document.createElement('canvas')
  img.width = 390 // 设置每一块的宽度
  img.height = 200 // 高度
  const imgs= img.getContext('2d') // 获取canvas画布
  imgs.rotate(-20 * Math.PI / 180) // 逆时针旋转π/9
  imgs.font = '20px Vedana' // 设置字体
  imgs.fillStyle = 'rgb(57,57,65)' // 设置字体的颜色
  imgs.textAlign = 'left' // 文本对齐方式
  imgs.textBaseline = 'Middle' // 文本基线
  imgs.fillText(str, 0, 4 * img.height / 5) // 绘制文字

  // 创建一个div元素
  const div = document.createElement('div')
  div.id = id // 设置id
  div.style.pointerEvents = 'none' // 取消所有事件
  div.style.top = '0px'
  div.style.left = '0px'
  div.style.position = 'absolute'
  div.style.zIndex = '100000'
  div.style.width = containerWidth + 'px'
  div.style.height = containerHeight + 'px'
  div.style.background = 'url(' + img.toDataURL('image/png') + ') left top repeat'

  container.appendChild(div) // 追加到页面

  return id
}

// 该方法只允许调用一次
watermark.set = (str, container) => {
  let id = setWatermark(str, container)
  setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWatermark(str, container)
    }
  }, 500)
  // 监听页面大小的变化
  window.onresize = () => {
    setWatermark(str, container)
  }
}

export default watermark
